export default {
    intro: `มาหาตัวอักษรเมล็ดพันธุ์ที่ซ่อนอยู่ในคำกันเถอะ!<br />
            วันนี้เราจะมาเรียนรู้ { first }, { second } กัน`,
    options: {
        textbook: 'คำที่อยู่ในหนังสือเรียน',
        page: 'หนังสือเรียน',
    },
    header: {
        round: ({ values }: { values: { round: number } }) => {
            const { round } = values;
            return `ตัวอักษรตัว${round === 1 ? 'ที่หนึ่ง' : 'ที่สอง'}`;
        },
        title: {
            word: 'ตัวอักษร',
            example1: 'คำตัวอย่าง1',
            example2: 'คำตัวอย่าง2',
            check: 'ตรวจสอบคำที่เรียน',
            question: 'โจทย์คำ',
            meaning: 'ตรวจสอบความสัมพันธ์เชิงความหมาย',
            meaningQuestion: 'โจทย์ความสัมพันธ์เชิงความหมาย',
        },
    },
    indicator: {
        word: 'มาเรียนรูปร่าง เสียง และความหมายของตัวอักษรเมล็ดพันธุ์กัน',
        example1: 'มาเรียนว่าตัวอักษรเมล็ดพันธุ์ถูกใช้ในคำอย่างไร',
        example2: 'มาเรียนว่าตัวอักษรเมล็ดพันธุ์ถูกใช้ในคำอย่างไร',
        check: 'มาเรียนสองคำที่มีตัวอักษรเมล็ดพันธุ์อยู่ ',
        question: 'ในสองคำนี้ คำที่ใช้ตัวอักษร "{ reading }({ cn })" คือคำใด?',
        meaning: 'มาเรียนว่าตัวอักษรเมล็ดพันธุ์ถูกใช้ในคำอย่างไร',
        meaningQuestion: 'ความสัมพันธ์ระหว่าง { first } กับ { second } คืออะไร?',
        // 관계 설명(앞문장) — 관계 타입별(0유의/1반의/2상하/3동형/4다의). { first }/{ second }/{ sound }/{ meaning1 }/{ meaning2 } 보간
        desciption: {
            0: '<strong>{ first }</strong> กับ <strong>{ second }</strong> มีความหมายคล้ายกัน',
            1: '<strong>{ first }</strong> กับ <strong>{ second }</strong> มีความหมายตรงกันข้ามกัน',
            2: '<strong>{ first }</strong> ครอบคลุมความหมายของ <strong>{ second }</strong>',
            3: '<strong>{ first }</strong> กับ <strong>{ second }</strong> อ่านว่า { sound } เหมือนกัน แต่มีความหมายต่างกัน',
            4: '<strong>{ first }</strong> มีความหมายว่า <strong>{ meaning1 }</strong> และมีความหมายว่า <strong>{ meaning2 }</strong> ด้วย',
        },
    },
    toast: {
        cube: ({ values }: { values: { isTeacher: boolean } }) => {
            const { isTeacher } = values;
            return isTeacher
                ? 'เป็นช่วงที่นักเรียนหมุนลูกบาศก์เพื่อเรียนรู้ด้วยตนเอง'
                : 'ลองหมุนลูกบาศก์เพื่อเรียนรู้ตัวอักษรด้วยตนเองสิ';
        },
        wrongAnswer: {
            lead: 'มาลองคิดใหม่กันไหม?',
            body: 'ดูความหมายแล้วเลือกคำที่ถูกต้องดูสิ',
        },
    },

    description: ({ values }: { values: { type: number } }) => {
        const { type } = values;
        if (type === 0) {
            return 'คำพ้องความหมาย';
        }
        if (type === 1) {
            return 'คำตรงข้าม';
        }
        if (type === 2) {
            return 'ลำดับชั้น';
        }
        if (type === 3) {
            return 'พ้องรูป';
        }
        if (type === 4) {
            return 'หลายความหมาย';
        }
        if (type === 5) {
            return 'ไม่มี';
        }
        return 'ไม่มี';
    },
    relationResult: {
        lead: 'ความสัมพันธ์แบบนี้เรียกว่า',
        // 뒷문장 꼬리 — 동형(3)만 받침이 있어 '이라고'
        tail: ({ values }: { values: { type: number } }) => (values.type === 3 ? ' นั่นเอง' : ' นั่นเอง'),
    },
    result: {
        correct: 'ตอบถูก',
        incorrect: 'ตอบผิด',
        selected: 'เลือก',
    },
    buttons: {
        next: 'ถัดไป',
        learn: 'เรียนคำ',
        nextLearn: 'เรียนคำถัดไป',
        collectWord: 'รวมคำ',
        check: 'ตรวจสอบคำที่เรียน',
        seoncdLearn: 'เรียนตัวอักษรตัวที่สอง',
        relation: 'เรียนความสัมพันธ์เชิงความหมาย',
        prev: 'ก่อนหน้า',
        finishStudy: 'เรียนเสร็จ',
        desciption: 'ดูคำอธิบาย',
    },
    guide: {
        cube: 'คลิกลูกบาศก์เพื่อหมุน',
    },
    study: {
        example: 'ประโยคตัวอย่าง',
        meaning: 'ความหมาย',
    },
};
